<div style="align-items: center;">
    <div class="modal-heading">
        <div class="close-button invisible"></div>
        <div class="header-section">
            <span class="header-text">Trace Details </span>
        </div>
        <div class="close-button" (click)="closeDialog()">
            <mat-icon class="close-icon">close</mat-icon>
        </div>
    </div>

    <div class="info-card">

        <div class="row">
            
            <div class="col col-sm-12">
                <label>Name</label>
                <p>{{ traceDetails.firstName }} {{ traceDetails.lastName }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-6">
                <label>Email</label>
                <p>{{ traceDetails.email }}</p>
            </div>

            <div class="col col-sm-6">
                <label>Contact No</label>
                <p>{{ traceDetails.contactNo }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-6">
                <label>Updated Date</label>
                <p>{{ traceDetails.updatedAt | date : 'dd-MM-yyyy' }}</p>
            </div>

            <div class="col col-sm-6">
                <label>Uploaded File Name</label>
                <p>{{ traceDetails.refDocPath }}</p>
            </div>
        </div>

        <div class="row">
            <div class="col col-sm-12">
                <label>Comment</label>
                <p>{{ traceDetails.comment }}</p>
            </div>
        </div>

    </div>

</div>